<template>
  <div class="support-store">
    <modal :show="showModal" class="modal--medium">
      <div class="modal-body modal-body__white">
        <div v-if="!showSuccessMessage" class="text-center">
          <h4 class="text-center-sm pt-50-sm mb-20-sm">Let's get started</h4>
          <p class="mb-40 mb-50-sm text-center-sm">Welcome to Bulletin's Summer Showcase.</p>
          <p class="mb-20 mb-25-sm text-center-sm">
            Are you a retailer or brand?
            <label v-if="errors.first('userType')" class="block invalid"> Please select one: </label>
          </p>
          <bulletin-button
            @click="signup"
            :variant="signUpType === 'retailer' ? 'primary' : 'secondary'"
            class="width-280 width-100-sm mb-25"
          >
            Retailer
          </bulletin-button>
          <bulletin-button
            @click="apply"
            :variant="signUpType === 'brand' ? 'primary' : 'secondary'"
            class="width-280 width-100-sm mb-25"
          >
            Brand
          </bulletin-button>
          <form @submit.prevent="handleSubmit" class="clear mb-20 mb-20-sm text-center">
            <input v-model="signUpType" name="userType" type="hidden" v-validate="'required'" />
            <div class="width-280 mb-30">
              <label for="emailAddress" class="inline-block mb-8">Email Address</label>
              <input
                v-model.trim="email"
                id="emailAddress"
                data-test-id="signup_input_email"
                maxlength="100"
                type="email"
                placeholder="ex: jane@gmail.com"
                v-validate="'required|email'"
                :class="{ invalid: errors.first('email') }"
                name="email"
                class="input-main input-font-book lighter-placeholder"
              />
            </div>
            <bulletin-button v-if="!showLoader" class="form-group form-group-half"> submit </bulletin-button>
            <loader-static v-else class="centered"></loader-static>
          </form>
          <div class="flex-sm justify-center-sm">
            <router-link
              class="underline mb-40 mb-50-sm m-auto-sm"
              :to="{ name: 'signIn', query: { redirectToPage: this.$route.path.substring(1) } }"
            >
              Login with an existing account.
            </router-link>
          </div>
        </div>
        <div v-else class="text-center">
          <h4 class="mb-40 mb-50-sm">Thank you!</h4>
          <p class="mb-40 mb-50-sm"></p>
          <bulletin-button variant="primary" @click="close()">continue</bulletin-button>
        </div>
      </div>
    </modal>

    <div class="page-wrapper pt-0 pb-0" style="position: relative">
      <div class="hero split-screen">
        <img class="hero-img hide show-sm" src="@/assets/img/micro-sites/summer-showcase-hero.png" />
        <img class="hero-img hide-sm" src="@/assets/img/micro-sites/summer-showcase-hero.png" />
        <div class="content-container" :style="`backgroundColor: #ffb8a5; color: #154640`">
          <div class="content-container--positionalWrapper">
            <h4 class="font-size-13" style="color: #154640">MEET AND SHOP THE BLACK-OWNED</h4>
            <h4 class="mb-20 font-size-13" style="color: #154640">BRANDS ON BULLETIN</h4>
            <h2>Summer</h2>
            <h2>Showcase</h2>
            <div class="by-line">
              <div class="line font-cambon">
                Our Summer Showcase aims to help independent retailers take Aurora James' viral 15% Pledge, and commit
                to investing and stocking Black-owned brands for the long haul. Every meaningful wholesale partnership -
                every order - starts with a spark, and a sense of connection. We invite you, our incredible retailer
                community, to meet these remarkable brands, learn their stories, and fall in love with their products.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-wrapper page-wrapper--white pb-30 pt-30-sm pb-30-sm">
      <div class="container">
        <headline :title="'meet black owned brands'" class="mb-30-sm"></headline>
        <div class="grid-wrapper grid-wrapper--col__2 column-gap-default">
          <div>
            <video-player :options="{ ASSET_ID: 'hz1R02y84rDrJB6uRIdtprGG81Dt4F02KFL1xgexZW6DA', THUMB_TIME: '7' }" />
            <router-link
              :to="{ path: '/brands/golde' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Golde</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'tixVi2ycZcuj3NXF7SOhTCGMdaV003oCH5hsrt6mamDA', THUMB_TIME: '7' }" />
            <router-link
              :to="{ path: '/brands/alexandra-winbush' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Alexandra Winbush</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'u02bD3aUvzQsqmHVRSai1hioNESPFV6v5PmMu4UBpG5M', THUMB_TIME: '132' }" />
            <router-link
              :to="{ path: '/brands/gilded' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Gilded
            </router-link>
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'jiuPYb9p5aySsExKsHpSffcgKoiFgytBgEIF8y6zmO00', THUMB_TIME: '240' }" />
            <router-link
              :to="{ path: '/brands/olori' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Olori</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'ufDZ00mZ2yexQ4l7YgYYaHDZ5QHPUXxfb4I800GkE8LS8', THUMB_TIME: '7' }" />
            <router-link
              :to="{ path: '/brands/hanahana-beauty' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Hanahana Beauty</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'Ir9tQN28bIQI01hYXX4Pj3rCG302KKfJIsrEQOYLKbKSc' }" />
            <router-link
              :to="{ path: '/brands/the-noble-brand' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >The Noble Brand</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'oolJ9Iv19N9XGTA1Xw01WPSHTbCDYk21ZBX34p7L02ssk' }" />
            <router-link
              :to="{ path: '/brands/tai-lite' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >TAI LITE</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'lvE6100c601sz31vYVwDHwNJYqgMaXbPY00i2wzRel02U5g' }" />
            <router-link
              :to="{ path: '/brands/satya---sage' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Satya Sage</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'X00ygJMLCpicdLE6J7oPOM8TbV9eoUL91zMboXEwpTFg' }" />
            <router-link
              :to="{ path: '/brands/kaleidadope' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Kaleidadope</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'Eu7B00WzJzTOSprq5a7HuC02stxwkpasO31OY02y7KYTT00' }" />
            <router-link
              :to="{ path: '/brands/golden-flourish' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Golden Flourish</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: '8RGxwn6GVxY5EvLm02aCKDMj6CpPPhKoFYZTthJ5B024c', THUMB_TIME: '07' }" />
            <router-link
              :to="{ path: '/brands/actually-curious' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Actually Curious</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'CaB3Mg5YY3BCFKaDxmqZvPg00QM6FspTlVOsH9rjAcQA' }" />
            <router-link
              :to="{ path: '/brands/graphic-anthology' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Graphic Anthology</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'IBkc01AT6fjpQ7ekDCikIvLwnxVirhjxQaejbUbwHsR4', THUMB_TIME: '51' }" />
            <router-link
              :to="{ path: '/brands/eu-genia-shea' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >Eu'Genia Shea</router-link
            >
          </div>
          <div>
            <video-player :options="{ ASSET_ID: 'fQkokcdqt7JFiXZ6M76I6qhzUwROxqiCyNoIgvR0130000' }" />
            <router-link
              :to="{ path: '/brands/antik-lakay' }"
              class="mr-20 mt-20 mb-40 mr-0-sm block font-size-16 cambon-book-sm"
              >ANTIK LAKAY</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div class="page-wrapper page-wrapper--white pb-30 pt-30-sm pb-30-sm">
      <div class="container">
        <headline :title="'SHOP BLACK OWNED BRANDS'" class="mb-30-sm"></headline>
        <div class="grid-wrapper grid-wrapper--col__4">
          <retailer-tile v-for="(brand, i) in brandList" :key="'brand_' + brand.id + i" :data="brand" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RetailerTile from "./retailer-tile.vue";
import BrandsData from "@/data/_summerShowcase.json";
import BrandAPI from "@/services/api/brandApi.js";
import VideoPlayer from "./video.vue";
import FormAPI from "@/services/api/formApi.js";

const FormAPIService = new FormAPI();

export default {
  components: {
    RetailerTile,
    VideoPlayer,
  },
  data() {
    return {
      brandList: BrandsData,
      signUpType: "",
      email: "",
      showModal: false,
      showSuccessMessage: false,
      showLoader: false,
    };
  },
  beforeMount() {
    // this.showModal = this.determineShowModal();
  },
  methods: {
    signup,
    apply,
    handleSubmit,
    close,
    determineShowModal,
  },
};
function signup() {
  this.signUpType = "retailer";
}
function apply() {
  this.signUpType = "brand";
}
function close() {
  this.showModal = false;
}
async function handleSubmit() {
  const valid = await this.$validator.validate();
  if (!valid) return;
  this.showLoader = true;
  await FormAPIService.emailCapture({
    emailAddress: this.email,
    type: this.signUpType,
  });
  this.showLoader = false;
  this.close();
  localStorage.setItem("QUICK_SIGNUP_SUMMER_SHOWCASE", true);
}

function determineShowModal() {
  const didQuickSignup = localStorage.QUICK_SIGNUP_SUMMER_SHOWCASE === "true",
    isUser = this.$session.getUserInfo() !== null;
  if (isUser) {
    return false;
  } else {
    if (didQuickSignup) {
      return false;
    } else {
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base/vars.scss";
@import "../../../assets/sass/base/helpers.scss";
.hero {
  height: 550px;
  position: relative;
  &.split-screen {
    .hero-img {
      object-fit: cover;
      object-position: center;
      height: 100%;
      width: 50%;
      @include respond-to("small") {
        object-position: center;
        background-position: center top;
        position: relative;
        height: 290px;
        width: 100%;
      }
    }
    .content-container {
      position: absolute;
      left: 50%;
      top: 0px;
      height: 100%;
      width: 50%;
      @include respond-to("small") {
        display: flex;
        width: 100%;
        top: 50%;
        height: 50%;
        left: 0px;
        align-items: center;
        .line {
          display: block;
        }
        h2 {
          text-align: center;
        }
      }
      @include respond-to("medium") {
        h2 {
          font-size: 32px;
        }
        .lines {
          padding: 0 40px;
          .line {
            display: inline;
          }
        }
      }
      h2 {
        font-family: "Pilat Extended Bold";
        font-size: 35px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: unset;
        letter-spacing: normal;
        text-transform: uppercase;
        @include respond-to("small") {
          font-size: 20px !important;
        }
      }
    }
  }
  .content-container--positionalWrapper {
    text-align: center;
    position: relative;
    @include respond-to("small") {
      align-items: center;
      justify-content: center;
      width: 83%;
      margin: 0px auto;
    }
    @include respond-above("small") {
      margin-left: 18.2%;
      margin-right: 143px;
      margin: 0px auto;
      width: 380px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
    .by-line {
      margin-top: 20px;
      margin-bottom: 40px;
      font-family: "Cambon";
      font-size: 18px;
      @include respond-to("small") {
        margin-top: 15px;
        margin-bottom: 15px;
        font-size: 12px;
      }
      letter-spacing: 0.2px;
      div {
        text-align: center;
      }
    }
    button {
      width: 100%;
      @include respond-above("small") {
        width: 380px;
      }
    }
  }
}
</style>
